import { memo, useState } from 'react'

import classNames from 'classnames'

import { MissionLocationIcon } from '@local/assets/icons'

import Image, { ImageProps } from '@web/components/Image'
import photoInfra from '@web/libs/media/photoInfra'
import { useRegistToSequentialList } from '@web/libs/sequential'
import { Nullish } from '@web/types'

import MissionRollingCountAnimation from './MissionRollingCountAnimation'
import ParticleAnimation from './ParticleAnimation'
import styles from '../MissionCard/Content/ProgressStamp/ProgressStamp.module.scss'

interface Props {
  total: number
  count: number
  number: number
  image?: Nullish<ImageProps['src']>
  order?: number
}

const ROLLING_DURATION = 1

const CircleOverAnimation = ({ total, count, image, number, order = 1 }: Props) => {
  const [gradientAnim, setGradientAnim] = useState(false)
  const [rollingAnim, setRollingAnim] = useState(false)
  const [countColorAnim, setCountColorAnim] = useState(false)

  useRegistToSequentialList({
    order,
    onExecute: () => setGradientAnim(true),
    type: 'withPrev',
    delaySeconds: 0,
    durationSeconds: 1.4,
    id: `over-circle-${order}`,
  })
  useRegistToSequentialList({
    order,
    onExecute: () => {
      setRollingAnim(true)
      setCountColorAnim(true)
    },
    type: 'withPrev',
    delaySeconds: 0.2,
    durationSeconds: ROLLING_DURATION,
    id: `rolling-count-${order}`,
  })

  return (
    <div className={styles.circle_area}>
      <div className={styles.number}>{number + 1}</div>
      <>
        {image ? (
          <div className={styles.icon_area}>
            <Image
              className={styles.img}
              src={image}
              width="100%"
              height="100%"
              alt="리뷰"
              thumbnailType={photoInfra.type.f220_220_70_sharpen}
            />
          </div>
        ) : (
          <div className={styles.default_image_area}>
            <MissionLocationIcon className={styles.icon_location} aria-hidden="true" />
          </div>
        )}
        <div className={classNames(styles.count, { [styles.type_allow_over]: countColorAnim })} aria-hidden={!count}>
          <span className="place_blind">조회수 달성</span>
          <MissionRollingCountAnimation
            finalNumber={count}
            rolling={rollingAnim}
            height={14}
            durationSeconds={ROLLING_DURATION}
            rollingCount={4}
          />
          <ParticleAnimation order={order} className={styles.particle} delaySeconds={1} />
        </div>
        <div className={classNames(styles.gradient_area, { [styles.apply_animation]: gradientAnim })} />
      </>
    </div>
  )
}

export default memo(CircleOverAnimation)
